/* dev-meta-lead.js */

/*
  Reports a pre-launch signup to Meta as a Lead. Shared by dev-prelaunch-hero
  and dev-launch-popup: both are the same capture (an address in exchange for
  launch access), so they must report identically or the numbers stop meaning
  one thing.

  event_id is sha256 of the normalised address. The "Customer created" Flow
  workflow derives it the same way with `| strip | downcase | sha256`, which is
  what lets Meta collapse the browser and server events into one Lead instead of
  counting two. That agreement is the whole point of this file — three separate
  copies of the normalisation would drift, and dedup would fail silently.
*/

(function () {
  if (window.RGDLead) return; // both sections load this; only the first wins

  var PIXEL_WAIT_MS = 8000;

  // Must match the Flow workflow's `| strip | downcase`.
  function normaliseEmail(value) {
    return String(value).trim().toLowerCase();
  }

  function sha256Hex(value) {
    return crypto.subtle
      .digest('SHA-256', new TextEncoder().encode(value))
      .then(function (digest) {
        return Array.from(new Uint8Array(digest))
          .map(function (byte) {
            return byte.toString(16).padStart(2, '0');
          })
          .join('');
      });
  }

  // web-pixels-manager injects fbq asynchronously, several hops after the
  // deferred section scripts run, so a one-shot `typeof fbq` check loses the
  // race on a cold cache and the Lead vanishes with no error. Wait for it.
  function whenPixelReady(callback) {
    var deadline = Date.now() + PIXEL_WAIT_MS;
    (function poll() {
      if (typeof window.fbq === 'function') {
        callback();
      } else if (Date.now() < deadline) {
        window.setTimeout(poll, 100);
      }
    })();
  }

  window.RGDLead = {
    /*
      Call on submit. The form does a full POST/redirect, so the address is gone
      from the DOM by the time the success state renders — park it while we
      still have it. Its presence later is also what proves a real signup
      happened in this session: Shopify renders the success state from
      ?customer_posted=true alone, so the DOM can't tell us that by itself.
    */
    remember: function (key, rawEmail) {
      if (!rawEmail) return;
      try {
        window.sessionStorage.setItem(key, normaliseEmail(rawEmail));
      } catch (error) {
        // Private mode. The Flow server event still reports this lead.
      }
    },

    /*
      Call when the success state renders. Silent unless this session actually
      submitted — a reload of the success URL, or someone opening it directly,
      reports nothing.
    */
    track: function (key, contentName) {
      var email = null;
      try {
        email = window.sessionStorage.getItem(key);
        // Consume before anything can fail: one signup, at most one Lead,
        // however many times the success state re-renders.
        window.sessionStorage.removeItem(key);
      } catch (error) {
        return;
      }
      if (!email) return;

      sha256Hex(email)
        .then(function (eventId) {
          whenPixelReady(function () {
            window.fbq('track', 'Lead', { content_name: contentName }, { eventID: eventId });
          });
        })
        .catch(function () {
          // Without a matching event_id the browser event would double-count
          // against the server one, so drop it and let Flow report alone.
        });
    },
  };
})();
